import { combineReducers } from "redux"
import baseStore from "./header/base"

const headerReducers = combineReducers({
  baseStore,
})

export default headerReducers
